<div class="modal-delete">
  <div class="modal-delete__header">
    <h2 class="modal-delete__title">
      {{ 'shop-settings.roles.rolesModalDelete.title' | translate }}
    </h2>
    <button class="modal-delete__close" (click)="close(false)">
      <app-icon class="icon-close" [icon]="IconName.CLOSE" />
    </button>
  </div>
  <p class="modal-delete__text">
    {{ 'shop-settings.roles.rolesModalDelete.deleteConfirm' | translate }}
  </p>
  <div class="modal-delete__btnWrapper">
    <button class="modal-delete__button btn-white" (click)="close(false)">
      {{ 'shop-settings.roles.rolesModalDelete.cancel' | translate }}
    </button>
    <button class="modal-delete__button btn-primary" (click)="close(true)">
      {{ 'shop-settings.roles.rolesModalDelete.confirm' | translate }}
    </button>
  </div>
</div>
